module.exports = __webpack_public_path__ + "img/rest-menu-icon.881b29fe.svg";